/* @flow */

import { combineReducers } from 'redux';

import Auth from './Auth';
import School from './School';
import City from './City';
import Level from './Level';
import Subject from './Subject';
export default combineReducers ({
    Auth,
    School,
    City,
    Level,
    Subject
})